import { useMemo } from 'react';
import useAnalyticsTheme from './useAnalyticsTheme';
import { createAnalyticsSx } from '../styles/analyticsLayout';

export default function useAnalyticsSx() {
  const tokens = useAnalyticsTheme();
  return useMemo(() => createAnalyticsSx(tokens), [tokens]);
}
